// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-image {
  height: 140px;
  background-size: cover;
  background-position: center;
  position: relative;
}
.news-image-overlay {
  position: absolute;
  right: var(--ion-padding, 16px);
  bottom: var(--ion-padding, 16px);
}
.news-image-overlay ion-badge {
  display: block;
}

p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-event-item/ax-event-item.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,+BAAA;EACA,gCAAA;AACJ;AACI;EACE,cAAA;AACN;;AAIA;EACE,SAAA;AADF","sourcesContent":[".news-image {\n  height: 140px;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n\n  &-overlay {\n    position: absolute;\n    right: var(--ion-padding, 16px);\n    bottom: var(--ion-padding, 16px);\n\n    ion-badge {\n      display: block;\n    }\n  }\n}\n\np {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
